import IBModuleApi from "../../api/iuviBankingAPI";
import { urlContexts } from "../../constants";

export const getWidgets = async (appId: string) => {
  const { data } = await IBModuleApi.get(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/widgets?appId=${appId}`
  );

  return data;
};

export const createWidget = async (createInfo: any, appId: string) => {
  const { data } = await IBModuleApi.post(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/widgets?appId=${appId}`,
    createInfo
  );

  return data;
};

export const updateWidget = async (updateInfo: any, appId: string) => {
  const { data } = await IBModuleApi.put(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/widgets?appId=${appId}`,
    updateInfo
  );

  return data;
};

export const deleteWidget = async (widgetId: number, appId: string) => {
  const { data } = await IBModuleApi.delete(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/widgets/${widgetId}?appId=${appId}`
  );

  return data;
};
